import { ofType } from 'redux-observable';
import { switchMap } from 'rxjs/operators/switchMap';
import { map } from 'rxjs/operators/map';
import { SiteService } from '../../services';

import {
  types as actions,
  setSiteUserAction
} from '../../reducers/actions';

export default function(action$, store) {
  return action$.pipe(
    ofType(actions.GET_SITE_USER),
    switchMap(action => 
      SiteService.getSiteUser(store, action.siteId).pipe(
        map(data => {
          return setSiteUserAction(data.response);
        })
      )
    )
  );
}



// WEBPACK FOOTER //
// ./src/epics/sites/getSiteUser.js